import { Component, Input } from '@angular/core';
import { NavigationTree } from './navigation-tree.constant';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';

@Component({
    selector: 'navigation-tree',
    templateUrl: './navigation-tree.component.html',
    styleUrls: ['./navigation-tree.component.scss'],
    providers: [{ provide: TRANSLOCO_SCOPE, useValue: { scope: 'layout' } }],
    standalone: false
})
export class NavigationTreeComponent {
  @Input() navigationTree: NavigationTree;
}
